import { FiltersType, ListingRequest } from '@/api/types';
import { client } from '@/client';
import { Group } from '@/client/groups';
import { useAppSelector } from '@/hooks/store';
import { selectCurrentAccount } from '@/store/features/account';
import React, { HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';
import { LazyLoadingSelect } from '../generic/LazyLoadingSelect';

type GroupsSelectInputProps = {
  onChange: (value: Group) => void;
  additionalFilters?: FiltersType;
  selectedValue?: Group;
  isDisabled?: boolean;
} & Omit<HTMLAttributes<HTMLSelectElement>, 'onChange' | 'defaultChecked'>;

export const GroupsSelectInput: React.FC<GroupsSelectInputProps> = ({
  onChange,
  className,
  additionalFilters,
  selectedValue,
  isDisabled,
}) => {
  const { t } = useTranslation();
  const currentAccount = useAppSelector(selectCurrentAccount);
  const additionalOption = {
    label: t('generic.none'),
    name: t('generic.none'),
    id: 'none',
  };

  const fetchGroups = isDisabled
    ? undefined
    : async (params: ListingRequest) =>
        await client.groups.getGroups(params, currentAccount?.id);

  return (
    <LazyLoadingSelect
      fetchService={fetchGroups}
      filter
      optionLabel="name"
      placeholder={t('group.select')}
      additionalFilters={additionalFilters}
      additionalOption={additionalOption}
      selectedValue={selectedValue}
      className={className}
      handleOnChange={onChange}
      disabled={isDisabled}
    />
  );
};
